<template>
  <div class="relative w-full">
    <div
      :class="{ disconnected: !isConnected }"
      class="chat-component flex flex-row"
    >
      <!-- <div class="menu bg-valhalla p-8">
        <div
          class="chat-actions text-color-topaz-light font-museo-700 text-s flex flex-col gap-2"
        >
          <button class="text-left" @click="showChatUsers(chatId)">
            Ver usuarios
          </button>
          <button class="text-left" @click="leaveChat(chatId)">
            Salir del chat
          </button>
        </div>

        <div class="separator gray-border"></div>

        <div class="user-actions flex-1 flex flex-col-reverse h-3/4">
          <button
            class="font-museo-300 text-xs flex flex-row justify-center select-none"
            @click="router.push({ name: 'ChatPage' })"
          >
            <p>
              Crea grupos privados entre <br />
              tus amigos y, monta el plan!
            </p>
            <w-icon
              size="38"
              img="https://cdn.wegow.com/no-delete/wegow/arrow-right.svg"
            />
          </button>
        </div>
      </div> -->

      <div class="chat">
        <header
          class="relative mt-0 py-2 md:text-[18px] font-museo-500 px-8 flex justify-between chat__header"
        >
          <h4 v-if="chat?.title || chat?.event?.title" class="title">
            {{ chat?.title || chat?.event?.title }}
          </h4>
          <h4 v-else-if="venue && venue.name">Friends {{ venue.name }}</h4>
          <w-icon
            class="rotate-90 cursor-pointer"
            :size="27"
            :img="require('@/assets/images/ic-options-dots.svg')"
            @click="openDialog = !openDialog"
          ></w-icon>
          <w-dialog
            id="chat-dialog"
            :show-dialog="openDialog"
            width="150px"
            height="fit-content"
          >
            <template #dialog>
              <header>
                <p
                  v-if="chat?.title || chat?.event?.title"
                  class="text-color-white dialog-text"
                >
                  {{ chat?.title || chat?.event?.title }}
                </p>
                <p
                  v-else-if="venue && venue.name"
                  class="text-color-white dialog-text"
                >
                  Friends {{ venue.name }}
                </p>
                <p v-if="chat?.title" class="text-color-gray dialog-text">
                  {{ chat.event.title }}
                </p>
              </header>
              <div class="separator gray-border--no-margin my-3"></div>
              <div
                class="chat-actions text-color-topaz-light font-museo-700 text-s flex flex-col gap-2"
              >
                <button
                  v-if="!isChatVenue"
                  class="text-left dialog-text"
                  @click="showChatUsers(chatId)"
                >
                  {{ $t("wegow.dialogs.seeUserTitle") }}
                </button>
                <button
                  v-if="!isChatVenue"
                  class="text-left dialog-text"
                  @click="router.push({ name: 'ChatPage' })"
                >
                  {{ $t("wegow.chat.createChat") }}
                </button>
                <button
                  class="text-left dialog-text"
                  @click="leaveChat(chatId)"
                >
                  {{ $t("wegow.chat.exitToChat") }}
                </button>
              </div>
            </template>
          </w-dialog>
        </header>
        <article>
          <w-chat-container
            :chat="chat"
            :is-venue="venueId !== undefined"
            height="160px"
          />
        </article>
      </div>
    </div>
    <div class="absolute top-[46%] md:left-[38%] left-[25%]">
      <wegow-button
        v-if="!isConnected && !isAuth"
        :button-id="`chat-button-${chatId}`"
        type="button"
        text="Unirse al chat"
        background="opacity"
        color="topaz"
        @click="
          openModal(SIGN_IN);
          isClick = true;
        "
      />
      <follow-button
        v-else-if="!isConnected && event.id && !event?.user?.tracking"
        :item="event"
        type="event"
        text="Unirse al chat"
        background="opacity"
        color="topaz"
        @click="
          connectToChat();
          isClick = true;
        "
      />
      <wegow-button
        v-else-if="!isConnected"
        :button-id="`chat-button-${chatId}`"
        type="button"
        text="Unirse al chat"
        background="opacity"
        color="topaz"
        @click="
          connectToChat();
          isClick = true;
        "
      />
    </div>
  </div>
</template>

<script setup>
import WChatContainer from "@/components/general/ui/elements/WChatContainer.vue";
import WegowButton from "@/components/general/forms/WegowButton.vue";
import WIcon from "@/components/general/ui/elements/WIcon.vue";
import WDialog from "@/components/general/ui/WDialog";

import { computed, onBeforeMount, ref, toRefs, watch } from "vue";
import { useChat } from "@/composables/useChat";
import { useUser } from "@/composables/useUser";
import { useEvent } from "@/composables/useEvent";
import { useVenue } from "@/composables/useVenue";
import { useModalHandler } from "@/plugins/useModalHandler";
import { useRouter } from "vue-router";
import FollowButton from "@/components/general/FollowButton.vue";
import { FollowVenueError } from "@/plugins/errors/user-errors";

const {
  ws,
  getChatById,
  getChatVenueId,
  addMessage,
  isChatVenue,
  joinChat,
  openWS,
  openVenueWS,
  removeChat,
  bubbleChatOpen: chat,
  sendChatVenueId
} = useChat();
const { openModal, MODAL_CHAT_USERS, SIGN_IN } = useModalHandler();
const { userDetail, isAuth } = useUser();
const { details: event, followEvent } = useEvent();
const { details: venue, followVenue } = useVenue();
const router = useRouter();
const openDialog = ref(false);
const isClick = ref(false);

const props = defineProps({
  chatId: { type: [Number, String], default: undefined },
  checkFollowUser: { type: Boolean, default: false },
  venueId: { type: [Number, String], default: undefined }
});
const emit = defineEmits(["updateEvent"]);
const { chatId } = toRefs(props);

const message = ref(null);
const isConnected = ref(false);

const showChatUsers = chatId => openModal(MODAL_CHAT_USERS, { chatId: chatId });
const connectToChat = async () => {
  if (props.venueId) {
    await getChatVenueId({ id: chatId.value });
    await openVenueWS(props.venueId);
  } else {
    await joinChat({ chat: chatId.value, user: userDetail.value.id });
    await getChatById({ id: chatId.value });
    await openWS();
  }
  isConnected.value = true;
};

const leaveChat = async chat => {
  await removeChat({ chat: chat });
  isConnected.value = false;
};
const init = () =>
  (async () => {
    if (props.venueId) {
      if (isAuth.value) {
        followVenue(venue.value);
        connectToChat();
      }
    } else if (event.value.id) {
      if (props.checkFollowUser && event.value?.user?.tracking) {
        connectToChat();
      } else if (props.checkFollowUser && !event.value?.user?.tracking) {
        followEvent(event.value);
        connectToChat();
      }
    }

    if (props.venueId) {
      await openVenueWS(props.venueId);
    } else {
      await getChatById({ id: chatId.value });
      await openWS();
    }
  })().catch(() => (isConnected.value = false));

onBeforeMount(() => init());
watch(isAuth, async nextsource => {
  if (isAuth.value && isClick.value) {
    emit("updateEvent");
  }
});
watch(ws, async newWs => {
  if (props.venueId) {
    ws.value.onopen = async () => {
      if (ws.value.readyState === 1) {
        await sendChatVenueId({
          chat: chatId.value,
          action: "initial"
        });
        ws.value.addEventListener("message", event => {
          addMessage(event.data);
        });
      }
    };
  }
});
</script>
<style lang="scss" scoped>
.chat-component {
  overflow: hidden;
  border-radius: 10px;
  @media screen and (min-width: $screen-md) {
    height: fit-content;
  }
}
.chat-component:is(.disconnected) {
  @apply blur-sm;
}
.chat {
  background-color: $backgroundGrey;
  width: 100%;
  &__header {
    height: fit-content;
  }
}
.dialog-text {
  font-size: 10px;
}
h1.dialog-text {
  overflow: hidden;
  text-overflow: ellipsis;
  text-align: start;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}
.title {
  font-size: 18px;
}
</style>
